import React from "react";

export default function CircleLoader(){
    return <div className="circle-loader">
        <div className="circle-loader-wrapper">
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
        </div>
}